<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardConver
            :content="content"
            :checkWidth="widthScreen"
            @nextRoute="nextRoute"
          />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardConver from './components/CardConver.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardConver, LoadingMDL},
  name: 'CTT02',
  data() {
    return {
      content: {},
      widthScreen: window.innerWidth.toString(),
      lang: this.$store.getters['language/getLanguage'],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      pageCode: '',
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      topicId: '',
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.loading = false;
    },
  },

  mounted() {},

  created() {
    this.onLoad();
  },

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `CTT02-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    nextRoute(val) {
      // let str = val.split('-');
      // this.$router.push("/" + str[0] + "/" + str[1]);
      // const useTime = this.$helpers.getUseTime();
      // this.userTemplateData.template = this.$helpers.setUserCriteria(
      //   this.userTemplateData.template,
      //   useTime
      // );
      // if (this.userTemplateData.quiz.length !== 0) {
      //   this.userTemplateData.quiz = this.$helpers.setUserQuizScore(
      //     this.userTemplateData.quiz,
      //     this.score
      //   );
      // }
      // this.nextAction = '/' + str[0] + '/' + str[1];
      /*
      this.$store.dispatch(
        "template/saveUserTemplateData",
        this.userTemplateData
      );
      */
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // });

      //data form
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //dispatch
      this.$store.dispatch('v3/saveContent', data);

      const path = val.split('-');
      const nextPath = `/v3/${path[0]}/${path[1]}`;

      //to LTK 01
      this.$router.push(nextPath);
    },
  },
};
</script>
<style></style>
